import Axios from '@/utils/request'
import { addSign } from "@/utils/tools"

// 获取站点信息接口
export const stationInfoApi = (params) => Axios.post('station/pdah5/v1/station/getOnlyStation', params)

//加油员归属站点站价详情
export const getDoperStationPriceApi = (params) => Axios.post('station/pdah5/v1/price/getDoperStationPrice', params)

// 获取加油员归属站点的站价信息
export const getStationPriceApi = (params) => Axios.post('station/pdah5/v1/station/getStationPricePaginate', params)

// 加油员发起调价申请
export const createChangePriceApproveApi = (params) => Axios.post('station/pdah5/v1/price/createChangePriceApprove', params)

// 获取加油员归属站点的站价信息
export const getPdaPriceApproveApi = (params) => Axios.post('station/pdah5/v1/price/getPdaPriceApprovePaginate', params)

// 获取订单列表接口
export const orderListApi = (params) => Axios.post('order/pdah5/api/order/getOrderPaginate', params)

// 获取合作订单列表接口
export const getCooperateOrderPaginate = (params) => Axios.post('order/pdah5/api/order/getCooperateOrderPaginate', params)

// 识别车牌号
export const parseTruckNoByImg = (params) => Axios.post('user/pdah5/api/ocr/parseTruckNoByImg', params)

// 获取合作费率
export const getCooperateRate = (params) => Axios.post('station/pdah5/v1/gasUser/getCooperateRate', params)

// 设置合作费率
export const setCooperateRate = (params) => Axios.post('station/pdah5/v1/gasUser/setCooperateRate', params)

// 获取合作订单列表接口
export const getCooperateList = (params) => Axios.post('station/pdah5/v1/gasUser/getCooperateList', params)

// 获取合作站点商品信息
export const getCooperateStationGoods = (params) => Axios.post('station/pdah5/v1/gasUser/getCooperateStationGoods', params)

// 上传文件
export const uploadFile = (params) => Axios.post('user/pdah5/api/upload/file', params)

// 获取订单详情接口
export const orderDetailApi = (params) => Axios.post('order/pdah5/api/order/getOrderItem', params)

// 申请退款接口
export const refundApplyApi = (params) => Axios.post('order/pdah5/api/order/refundApprove', params)

// 下单前获取商品信息接口
export const goodsBaseApi = (params) => Axios.post('order/pdah5/api/order/getGoodsLimit', params)

//下单接口
export const createOrderApi = (params) => Axios.post('order/pdah5/api/order/createOrder', params)

// 下单新接口
export const cashierEnterOrder = (params) => Axios.post('order/pdah5/api/order/cashierEnterOrder', params)

//检查下单前订单接口
export const checkOrderApi = (params) => Axios.post('order/pdah5/api/order/checkStationLatestOrder', params)

export const historyPaginateApi = (params) => Axios.post('order/pdah5/api/order/getHistoryPaginate', params)

//获取账户列表
export const getUserRelation = (params) => Axios.post('station/pdah5/v1/gasUser/getUserRelation', params)

//切换账号
export const switchUserRelation = (params) => Axios.post('station/pdah5/v1/gasUser/switchUserRelation', params)

//删除账号
export const delUserRelation = (params) => Axios.post('station/pdah5/v1/gasUser/delUserRelation', params)

//添加账号
export const addUserRelation = (params) => Axios.post('station/pdah5/v1/gasUser/addUserRelation', params)

//获取订单退款申请原因
export const getOrderRefundReason = (params) => Axios.post('order/pdah5/api/order/getOperateOrderReason', params)
//获取订单退款申请原因
export const getMaxDay = (params) => Axios.post('order/pdah5/api/order/getMaxDay', params)



